<template>
  <div class="pa-1" id="topics">
    <!--タイトル-->
    <span class="subHead px-5">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--内容-->
          <div class="">
          <v-col v-for="(item, i) in contents"
      :key="i">
         <v-card-title class="descriptiontitle">

              {{ item.descriptiontitle }}
              </v-card-title>
              <v-card-text class="summary" style="white-space:pre-wrap; word-wrap:break-word; margin-top:-1rem;">
                {{ item.description }}
              </v-card-text>
              </v-col>
              </div>
              <div style="text-align:center; color:#C62828;" class="px-7">試用など各種ご相談お問い合わせは、こちらからお願いいたします。</div>
  </div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
.descriptiontitle{
    font-size: 18px;
  color:#345fb5;
}
hr{
    max-width: 1200px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: 'トピックス',
      // タイトル横のアイコン
      icon: 'mdi-newspaper-variant-multiple-outline',
      contents: [
        {
          // 説明タイトル
          descriptiontitle: 'SIAPのe-Learnigコースの事前試験である SIAP proficiency test (期間: 2014年2月5日 ～ 2014年4月10日) に採用されました。',
          // 説明文
          description: `
2014年2月5日

国連アジア太平洋統計研修所（SIAP）様のe-Learnigコースの事前試験である
SIAP proficiency test
(期間: 2014年2月5日 ～ 2014年4月10日)
に採用されました。`
        },
        {
          // 説明タイトル2
          descriptiontitle: 'SIAPのe-Learnigコースである First Intermediate-level e-learning Course on System of National Accounts (期間: 2013年6月3日 ～ 2013年8月16日) に採用されました。',
          // 説明文2
          description: `
2013年6月3日

国連アジア太平洋統計研修所（SIAP）様のe-Learnigコースである
First Intermediate-level e-learning Course on System of National Accounts
(期間: 2013年6月3日 ～ 2013年8月16日)
に採用されました。`
        },
        {
          // 説明タイトル3
          descriptiontitle: 'SIAPのe-Learnigコースである e-Learning Course on the 2008 System of National Accounts (期間: 2012年11月15日 ～ 2013年1月14日) に採用されました。',
          // 説明文3
          description: `
2012年11月15日

UNSIAPのe-Learnigコースである
e-Learning Course on the 2008 System of National Accounts
(期間: 2012年11月15日 ～ 2013年1月14日)
に採用されました。`
        },
        {
          // 説明タイトル4
          descriptiontitle: 'SIAPのe-Learnigコースである Introduction to System of National Accounts (期間: 2012年8月1日 ～ 2012年9月30日) に採用されました。',
          // 説明文4
          description: `
2012年8月1日

国連アジア太平洋統計研修所（SIAP）様のe-Learnigコースである
Introduction to System of National Accounts
(期間: 2012年8月1日 ～ 2012年9月30日)
に採用されました。`
        },
        {
          // 説明タイトル5
          descriptiontitle: 'SIAPのe-Learningコースに弊社が開発したe-Learningシステムが採用されました。',
          // 説明文5
          description: `
2011年11月1日

国連アジア太平洋統計研修所（SIAP）様のe-Learnigコースである
Introduction to System of National Accounts
(期間: 2011年11月1日 ～ 2011年12月31日)
に弊社が開発したe-Learningシステムが採用されました。`
        }
      ]
    }
  }
}
</script>
